import { optional, optionalQueryBoolean, optionalString, string, z, zodLess, ZodLessInfer } from '@kaiizen/zod-less';
import { LimitSchema } from './schemaLib';

export const PropertyProjectSortBySchema = zodLess('updatedAt|relevance');
const orgMarketIdsQuerySchema = z.preprocess(
  value =>
    Array.isArray(value)
      ? value.map(item => `${item}`.trim()).filter(Boolean)
      : typeof value === 'string'
      ? value.split(',').map(item => item.trim()).filter(Boolean)
      : value,
  z.array(string),
);

export const PropertyProjectQuerySchema = zodLess({
  orgMarketId: optionalString.meta({ deprecated: true, description: 'Filter by organization market ID. Use orgMarketIds instead.' }),
  orgMarketIds: optional(orgMarketIdsQuerySchema),
  orgPropertyId: optionalString,
  assignedToUserId: optionalString,
  needsAttention: optionalQueryBoolean,
  search: optionalString,
  limit: optional(LimitSchema),
  archived: optionalQueryBoolean.meta({ description: 'Filter by archived status. Defaults to false (i.e. non-archived projects).', example: true }),
  includeArchived: optionalQueryBoolean.meta({
    description: 'Include archived projects alongside non-archived projects. The archived filter takes precedence when both are supplied.',
    example: true,
  }),
  status: optional('active|completed').meta({ description: 'Filter by status. Defaults to undefined (i.e. all projects).', example: 'active' }),
  sortBy: optional(PropertyProjectSortBySchema),
});

export type PropertyProjectQuery = ZodLessInfer<typeof PropertyProjectQuerySchema>;
